

import axios from 'axios';
import fileDownload from 'js-file-download';

export default {
  name: 'SemesterCapacity',
  props: {
    currentSemesterProp: {type: Object, required: true},
    comparativeSemesterProp: {type: Object, required: true},
    semesters: {type: [Object], required: true},
    fetchDataTable1Url: {type: String, required: true},
    fetchDataTable2Url: {type: String, required: true},
    downloadTable2Url: {type: String, required: true},
    employeeBaseUrl: {type: String, required: true},
    courseBaseUrl: {type: String, required: true},
    editProcessingStatusUrl: {type: String, required: true},
    editCommentUrl: {type: String, required: true},
    deleteCommentUrl: {type: String, required: true},
  },
  data() {
    return {
      currentSemester: this.currentSemesterProp, // needs to be mutable
      comparativeSemester: this.comparativeSemesterProp, // needs to be mutable

      capacity: null,
      capacityInputValue: '',
      capacityInputState: null,

      commentPopoverIndex: null,
      editingComment: false,
      deleteCommentData: null,
      formatDurationsAsHours: false,

      isBusyTable1: false,
      errorTable1: false,
      fieldsTable1: [
        {key: 'contractType', label: 'Vertragstyp', headerTitle: 'hier klicken für Standard-Sortierung',
          sortable: false, filter: 'multiselect', thClass: 'th-contract-type'},
        {key: 'sumCompensationLevel1', label: 'VGS 1', headerTitle: 'Vergütungsstufe 1',
          sortable: true, formatter: ({value}) => this.formatDuration(value), tdClass: 'text-end'},
        {key: 'sumCompensationLevel2', label: 'VGS 2', headerTitle: 'Vergütungsstufe 2',
          sortable: true, formatter: ({value}) => this.formatDuration(value), tdClass: 'text-end'},
        {key: 'sumCompensationLevels', label: 'VGS 1&2', headerTitle: 'Summe Vergütungsstufen',
          sortable: true, formatter: ({value}) => this.formatDuration(value), tdClass: 'text-end'},
      ],
      itemsTable1: [],
      filterTable1: [],

      isBusyTable2: false,
      isExportingTable2: false,
      errorTable2: false,
      fieldsTable2: [
        {key: 'select', label: '', visible: true, class: 'select'},
        {key: 'lecturer', label: 'Name, Vorname', filter: {type: 'string-contains', value: ''}, visible: true},
        {key: 'contractType', label: 'Vertrag', visible: true,
          filter: {type: 'multiselect', value: [], options: []}},
        {key: 'contractCount', label: '#Verträge', visible: true, tdClass: 'text-end',
          filter: {type: 'multiselect', value: [], options: []}},
        {key: 'emailWWU', label: 'E-Mail (Uni)', filter: {type: 'string-contains', value: ''}, visible: true,
          tdClass: 'text-center'},
        {key: 'position', label: 'Aufgaben', visible: true,
          filter: {type: 'multiselect', value: '', options: []}},
        {key: 'coursesCL1', label: 'Titel VGS 1', headerTitle: 'Veranstaltungstitel Vergütungsstufe 1',
          filter: {type: 'string-contains', value: ''}, visible: true},
        {key: 'coursesCL2', label: 'Titel VGS 2', headerTitle: 'Veranstaltungstitel Vergütungsstufe 2',
          filter: {type: 'string-contains', value: ''}, visible: true},
        {key: 'lectureshipStatus', label: 'Status (LA)', headerTitle: 'Status Lehraufträge', visible: true,
          formatter: ({value}) => this.formatLectureshipStatus(value),
          filter: {type: 'multiselect', value: '', options: [
            {id: 'unchanged', name: 'Unverändert'},
            {id: 'changed', name: 'Änderung'},
            {id: 'new', name: 'Neu'},
          ]},
        },
        {key: 'comparativeCalculatedWorkloadTotal', label: 'Std. Vergleich', headerTitle: 'Stunden Vergleich',
          filter: {type: 'decimal-number-contains', value: ''}, visible: true,
          formatter: ({value}) => this.formatDuration(value), filterByFormatted: true, tdClass: 'text-end'},
        {key: 'processingStatus', label: 'Status (Bearb.)', formatter: ({value}) => this.formatProcessingStatus(value),
          filterByFormatted: true,
          filter: {type: 'multiselect', value: '', options: [
            {id: 'open', name: 'offen'},
            {id: 'transferred', name: 'übertragen'},
            {id: 'granted', name: 'erteilt'},
            {id: 'correct', name: 'korrekter Nachweis'},
            {id: 'incorrect', name: 'inkorrekter Nachweis'},
          ]},
          visible: true},
        {key: 'individualCapacity', label: 'Ind. Kap.', headerTitle: 'Individuelle Kapazität',
          filter: {type: 'decimal-number-contains', value: ''},
          visible: true, formatter: ({value}) => this.formatDuration(value),
          filterByFormatted: true, tdClass: 'text-end'},
        {key: 'calculatedWorkloadCL1', label: 'VGS 1', filter: {type: 'decimal-number-contains', value: ''},
          visible: true, formatter: ({value}) => this.formatDuration(value),
          filterByFormatted: true, tdClass: 'text-end'},
        {key: 'calculatedWorkloadCL2', label: 'VGS 2', filter: {type: 'decimal-number-contains', value: ''},
          visible: true, formatter: ({value}) => this.formatDuration(value),
          filterByFormatted: true, tdClass: 'text-end'},
        {key: 'calculatedWorkloadTotal', label: 'VGS  1&2', filter: {type: 'decimal-number-contains', value: ''},
          visible: true, formatter: ({value}) => this.formatDuration(value),
          filterByFormatted: true, tdClass: 'text-end'},
        {key: 'difference', label: 'Differenz', filter: {type: 'decimal-number-contains', value: ''},
          visible: true, formatter: ({value}) => this.formatDuration(value),
          filterByFormatted: true, tdClass: 'text-end'},
        {key: 'comment', label: 'Bemerkung', visible: true,
          filter: {type: 'string-contains', value: ''},
        },
      ],
      itemsTable2: [],
    };
  },
  computed: {
    durationFormatTooltipText(){
      return `Zeitdauern in ${this.formatDurationsAsHours ? 'Stunden und Minuten' : 'Stunden'} anzeigen`;
    },
    columnSumsTable1() {
      const result = {'compensationLevel1': 0, 'compensationLevel2': 0, 'compensationLevels': 0};
      this.filteredItemsTable1.forEach(function(row) {
        result.compensationLevel1 += row['sumCompensationLevel1'];
        result.compensationLevel2 += row['sumCompensationLevel2'];
        result.compensationLevels += row['sumCompensationLevels'];
      });
      return result;
    },
    contractTypeMultiselectOptions() {
      return this.itemsTable1.map((row) => {
        return {id: row['contractType'], name: row['contractType']};
      });
    },
    filteredItemsTable1() {
      return this.filterTable1.length ?
          this.itemsTable1.filter((item) => this.filterTable1.some((option) => option.id === item['contractType'])) :
          this.itemsTable1;
    },
    filteredFieldsTable2() {
      return this.fieldsTable2.filter((field) => field.filter && field.filter.value.length);
    },
    filteredItemsTable2() {
      return this.itemsTable2.filter((item) => {
        // go through all filters
        return this.fieldsTable2.filter((field) => field.filter).every((field) => {
          const filter = field.filter;
          // filter for string fields
          if (filter.type === 'string-contains') {
            if (filter.value === '') {
              return true;
            }
            return this.sanitizeString(this.stringify(item[field.key])).includes(this.sanitizeString(filter.value));
          }
          // filter for decimal number strings
          if (filter.type === 'decimal-number-contains') {
            if (filter.value === '') {
              return true;
            }
            if (field.filterByFormatted) {
              if (filter.value.includes('.')) {
                return field.formatter({value: item[field.key]}).includes(filter.value);
              } else {
                return field.formatter({value: item[field.key]}).replace(/\./g, '').includes(filter.value);
              }
            } else {
              return String(item[field.key]).includes(filter.value);
            }
          }
          // filter for multiselects
          if (filter.type === 'multiselect') {
            if (!filter.value.length) {
              return true;
            }
            if (field.filterByFormatted) {
              return filter.value.some(
                  (filter) => field.formatter({value: item[field.key]}) === field.formatter({value: filter.id}),
              );
            } else {
              return filter.value.some((filter) => item[field.key] === filter.id);
            }
          }
        });
      });
    },
    selectableFieldsTable2() {
      // select, name and contract type columns should always be visible
      return this.fieldsTable2.filter((field, index) => index > 2);
    },
    visibleFieldsTable2() {
      return this.fieldsTable2.filter((field) => field.visible);
    },
    allSelectedTable2() {
      return this.selectedRowsTable2.every(value => value === true);
    },
    selectedRowsTable2() {
      return this.itemsTable2.map((item, index) => this.$refs.table2.selection.isActivated(index));
    },
    combinedMailAddresses() {
      const items = this.selectedRowsTable2.length ? this.selectedRowsTable2 : this.filteredItemsTable2;
      if (items) {
        return items.map((item) => item['emailWWU']).filter(Boolean);
      }
      return '';
    },
  },
  watch: {
    'itemsTable2'() {
      // set contract type multiselect options
      this.fieldsTable2.find((field) => field.key === 'contractType')['filter'].options =
          this.contractTypeMultiselectOptions;

      // set contract count options
      this.fieldsTable2.find((field) => field.key === 'contractCount')['filter'].options = [
        ...new Map(
            this.itemsTable2.map(
                (row) => [row['contractCount'], {id: row['contractCount'], name: row['contractCount']}]),
        ).values(),
      ];

      // set position multiselect options
      const positionOptions = [
        ...new Map(this.itemsTable2.map((row) => [row['position'], {id: row['position'], name: row['position']}]))
            .values(),
      ];
      const emptyOption = positionOptions.find((option) => option.id === null);
      if (emptyOption) {
        emptyOption.name = 'nicht angegeben';
      }
      this.fieldsTable2.find((field) => field.key === 'position')['filter'].options = positionOptions;
    },
    'visibleFieldsTable2'() {
      const checkbox = $('#all-columns-checkbox');
      if (this.fieldsTable2.find((field) => !field.visible) !== undefined) {
        this.showAllColumns = false;
        checkbox.prop('checked', false);
      } else {
        this.showAllColumns = true;
        checkbox.prop('checked', true);
      }
      window.localStorage.setItem('semesterCapacityTable2ShowAllColumns', this.showAllColumns);
      if (!checkbox.prop('checked')) {
        const visibility = this.fieldsTable2.reduce((result, column) =>
          ({...result, [column.key]: column.visible}), {});
        window.localStorage.setItem('semesterCapacityTable2ColumnSettings', JSON.stringify(visibility));
      }
    },
  },
  mounted() {
    // initialize elements
    this.calculateContainerHeight();
    this.calculateBottomPanelDropdownHeights();
    this.initializeDragElement();
    this.initializeVisibleColumns();

    // load data
    this.initializeCapacity();
    this.fetchData(this.currentSemester, this.comparativeSemester);

    // add event listeners
    $(window).on('resize', this.calculateContainerHeight);
    const dropdownObserver = new ResizeObserver(() => {
      this.calculateBottomPanelDropdownHeights();
    });
    dropdownObserver.observe(this.$refs.splitPanelBottom.$el);
  },
  methods: {
    fetchData(semester, comparativeSemester = null) {
      this.currentSemester = semester;
      this.comparativeSemester = comparativeSemester ?
          this.comparativeSemester = comparativeSemester :
          this.semesters[
              Math.min(this.semesters.findIndex((s) => s.id === semester.id) + 1,
                  this.semesters.length - 1)
          ]; // select previous semester as default when comparativeSemester is not specified
      this.fetchDataTable1();
      this.fetchDataTable2();
    },
    fetchDataTable1() {
      this.isBusyTable1 = true;

      // reset table1 related variables
      this.errorTable1 = false;

      axios.get(this.fetchDataTable1Url, {
        params: {
          semester: this.currentSemester.id,
        },
      }).then((response) => {
        this.itemsTable1 = response.data;
      }).catch((error) => {
        this.errorTable1 = error;
        this.itemsTable1 = [];
      }).finally(() => {
        this.isBusyTable1 = false;
      });
    },
    fetchDataTable2(comparativeSemester = this.comparativeSemester) {
      this.comparativeSemester = comparativeSemester;
      this.isBusyTable2 = true;

      // reset table2 related variables
      this.errorTable2 = false;

      axios.get(this.fetchDataTable2Url, {
        params: {
          semester: this.currentSemester.id,
          comparativeSemester: this.comparativeSemester.id,
        },
      }).then((response) => {
        this.itemsTable2 = response.data;
      }).catch((error) => {
        this.errorTable2 = error;
        this.itemsTable2 = [];
      }).finally(() => {
        this.isBusyTable2 = false;
      });
    },
    initializeCapacity() {
      const value = window.localStorage.getItem('semesterCapacity');

      if (value === null) {
        return;
      }

      const capacity = Number(value);

      if (!isNaN(capacity)) {
        this.capacity = capacity;
      }
    },
    initializeVisibleColumns() {
      if (JSON.parse(window.localStorage.getItem('semesterCapacityTable2ShowAllColumns'))) {
        $('#all-columns-checkbox').prop('checked', true);
      } else {
        const visibility = JSON.parse(window.localStorage.getItem('semesterCapacityTable2ColumnSettings'));
        if (visibility) {
          Object.keys(visibility).forEach((column) => {
            const field = this.fieldsTable2.find((field) => field.key === column);
            field.visible = visibility[column];
          });
        }
      }
    },
    submitCapacity(bvModalEvent) {
      // prevent modal from closing before input is validated
      bvModalEvent.preventDefault();

      // validate input
      if (!this.capacityInputValue || this.capacityInputValue < 0) {
        this.capacityInputState = false;
        return;
      }
      // update capacity
      this.capacity = Number(this.capacityInputValue);
      window.localStorage.setItem('semesterCapacity', this.capacity);

      // hide modal and reset input value
      this.$nextTick(() => {
        this.$refs.capacityModal.hide();
        this.capacityInputValue = '';
      });
    },
    submitProcessingStatus(contractId, event, popover, cell) {
      const submitter = event.submitter;
      // replace submit button content with loading circle
      submitter.innerHTML='<span aria-hidden="true" class="spinner-border spinner-border-sm"></span>';
      // get status from form data
      const formData = new FormData(event.target);
      const status = Object.fromEntries(formData.entries())['status'];
      // send request
      axios.post(this.editProcessingStatusUrl, {
        contract: contractId,
        semester: this.currentSemester.id,
        status: status,
      },
      ).then(() => {
        // close popover and update value
        popover.hide();
        this.itemsTable2.find((item) => item['contractId'] === contractId)['processingStatus'] = status;
        // highlight table cell for one second
        cell.style.backgroundColor='lightgreen';
        setTimeout(() => {
          cell.style.transition='background-color 1s linear';
          cell.style.backgroundColor=null;
        }, 1000);
        cell.style.transition=null;
      }).catch((error) => {
        submitter.style.color='white';
        submitter.style.backgroundColor='#dc3545';
        submitter.style.borderColor='##dc3545';
        submitter.innerHTML='<i class="fa-solid fa-rotate-right"></i>';
        alert('Ein Fehler ist aufgetreten (' + error.message + ').');
      });
    },
    submitComment(contractId, event, popover, cell) {
      const submitter = event.submitter;
      // replace submit button content with loading circle
      submitter.innerHTML='<span aria-hidden="true" class="spinner-border spinner-border-sm"></span>';
      // get comment from form data
      const formData = new FormData(event.target);
      const comment = Object.fromEntries(formData.entries())['comment'];
      // send request
      axios.post(this.editCommentUrl, {
        contract: contractId,
        semester: this.currentSemester.id,
        comment: comment,
      }).then(() => {
        this.editingComment = false;
        // close popover and update value
        popover.hide();
        this.itemsTable2.find((item) => item['contractId'] === contractId)['comment'] = comment;
        // highlight table cell for one second
        cell.style.backgroundColor='lightgreen';
        setTimeout(() => {
          cell.style.transition='background-color 1s linear';
          cell.style.backgroundColor=null;
        }, 1000);
        cell.style.transition=null;
      }).catch((error) => {
        submitter.style.color='white';
        submitter.style.backgroundColor='#dc3545';
        submitter.style.borderColor='##dc3545';
        submitter.innerHTML='<i class="fa-solid fa-rotate-right"></i>';
        alert('Ein Fehler ist aufgetreten (' + error.message + ').');
      });
    },
    confirmCommentDelete(item, index) {
      this.deleteCommentData={
        index: index,
        name: item['lecturer']['value'],
        contractType: item['contractType'],
        comment: item['comment'],
        contractId: item['contractId'],
      };
      this.$refs.deleteCommentModal.show();
    },
    deleteComment() {
      const contractId = this.deleteCommentData.contractId;
      const index = this.deleteCommentData.index;
      const button = this.$refs['deleteCommentButton'];
      // replace button content with loading circle
      button.innerHTML='<span aria-hidden="true" class="spinner-border spinner-border-sm"></span>';
      axios.post(this.deleteCommentUrl, {
        contract: contractId,
        semester: this.currentSemester.id,
      }).then(() => {
        // close modal
        this.$refs.deleteCommentModal.hide();
        // set comment to null
        this.itemsTable2.find((item) => item['contractId'] === contractId)['comment'] = null;
        // highlight table cell for one second
        const cell = this.$refs['commentWrapper' + index].parentNode;
        cell.style.backgroundColor='lightgreen';
        setTimeout(() => {
          cell.style.transition='background-color 1s linear';
          cell.style.backgroundColor=null;
        }, 1000);
        cell.style.transition=null;
      }).catch((error) => {
        button.style.color='white';
        button.style.backgroundColor='#dc3545';
        button.style.borderColor='##dc3545';
        button.innerHTML='<i class="fa-solid fa-rotate-right"></i>';
        alert('Ein Fehler ist aufgetreten (' + error.message + ').');
      }).finally(()=> {
      });
    },
    downloadTable2() {
      this.isExportingTable2 = true;

      // get current contract ids
      let idList = [];
      if (this.selectedRowsTable2.every(value => value === false)) {
        idList = this.filteredItemsTable2.map((item) => item['contractId']);
      } else {
        idList = this.filteredItemsTable2
            .filter((item, index) => this.selectedRowsTable2[index])
            .map(item => item['contractId']);
      }
      // download file
      axios.post(this.downloadTable2Url, {
        semester: this.currentSemester.id,
        comparativeSemester: this.comparativeSemester.id,
        columns: this.visibleFieldsTable2.map((field) => field.key),
        contracts: idList,
      }, {responseType: 'blob'},
      ).then((response) => {
        fileDownload(response.data, 'Semesterkapazitäten.xlsx');
      }).catch((error) => {
        alert('Ein Fehler ist aufgetreten (' + error.message + ').');
      }).finally(() => {
        this.isExportingTable2 = false;
      });
    },
    toggleShowAllColumns() {
      const checkbox = $('#all-columns-checkbox');
      if (checkbox.prop('checked')) {
        this.selectableFieldsTable2.forEach((field, index, fields) => fields[index].visible = true);
      } else {
        const visibility = JSON.parse(window.localStorage.getItem('semesterCapacityTable2ColumnSettings'));
        if (visibility) {
          Object.keys(visibility).forEach((column) => {
            const field = this.fieldsTable2.find((field) => field.key === column);
            field.visible = visibility[column];
          });
        }
      }
    },
    calculateContainerHeight() {
      const windowHeight = $(window).outerHeight();
      const offsetTop = $('#table-wrapper-table1').offset().top;
      const footerHeight = $('.footer').outerHeight();
      const containerHeight = windowHeight - offsetTop - footerHeight - 16;
      this.$refs.splitContainer.style.height = containerHeight + 'px';
    },
    calculateBottomPanelDropdownHeights() {
      const offsetY = this.$refs.buttonGroupTable2.getBoundingClientRect().y;
      $('.bottom-panel-dropdown').each((index, el) => {
        // noinspection JSUnresolvedVariable
        el.style.height = window.innerHeight - offsetY - 120 + 'px';
      });
    },
    clearFilter(filter) {
      filter.value = filter.type !== 'multiselect' ? '' : [];
    },
    clearFilters() {
      this.fieldsTable2.forEach((field) => {
        const filter = field.filter;
        if (!filter) {
          return;
        }
        filter.value = filter.type !== 'multiselect' ? '' : [];
      });
    },
    copyTitles(value) {
      const uniqueTitles = [...new Set(value)];
      uniqueTitles.sort((a, b) => a.localeCompare(b, 'de-DE'));
      navigator.clipboard.writeText(uniqueTitles.join('; '));
      alert('Die Veranstaltungstitel wurden kopiert.');
    },
    openCommentPopover(index, editComment) {
      this.commentPopoverIndex = index;
      this.editingComment = editComment;
    },
    closeCommentPopover(index) {
      this.editingComment = false;
      this.$refs['commentPopover' + index].hide();
    },
    formatLectureshipStatus(status) {
      switch (status) {
        case 'new':
          return 'Neu';
        case 'unchanged':
          return 'Unverändert';
        case 'changed':
          return 'Änderung';
      }
    },
    formatProcessingStatus(status) {
      if (status === null) return 'offen';

      switch (status) {
        case 'open':
          return 'offen';
        case 'transferred':
          return 'übertragen';
        case 'granted':
          return 'erteilt';
        case 'correct':
          return 'korrekter Nachweis';
        case 'incorrect':
          return 'inkorrekter Nachweis';
      }
    },
    formatDecimalNumber(value) {
      return Number(value).toLocaleString('de-De', {maximumFractionDigits: 2, minimumFractionDigits: 2});
    },
    formatDuration(minutes) {
      if (minutes === null) return '';
      if (this.formatDurationsAsHours) {
        return this.formatDecimalNumber(minutes / 60);
      }
      return Math.trunc(minutes / 60) + ':' + String(Math.abs(minutes % 60)).padStart(2, '0');
    },
    toggleRowSelectionTable2(index) {
      if (this.$refs.table2.selection.isActivated(index)) {
        this.$refs.table2.selection.remove(index);
      } else {
        this.$refs.table2.selection.add(index);
      }
    },
    stringify(value) {
      if (value === null || typeof value === 'undefined') {
        return '';
      } else if (value instanceof Object) {
        return Object.keys(value)
            .sort()
            .map((key) => this.stringify(value[key]))
            .join(' ');
      } else {
        return String(value);
      }
    },
    sanitizeString(value) {
      return value.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '');
    },
    initializeDragElement() {
      // get elements
      const dragElement = $('#separator');
      const panelTop = $('#split-panel-top');
      const panelBottom = $('#split-panel-bottom');

      let mousedownInfo; // remember mouse down info

      dragElement.on('mousedown', onMouseDown);

      function onMouseDown(element) {
        mousedownInfo = {
          element,
          offsetLeft: dragElement.offset().left,
          offsetTop: dragElement.offset().top,
          panelTopHeight: panelTop.outerHeight(),
          panelBottomHeight: panelBottom.outerHeight(),
        };

        $(document).on('mousemove', onMouseMove);

        $(document).on('mouseup', () => {
          $(document).off('mousemove');
          $(document).off('mouseup');
        });
      }

      function onMouseMove(element) {
        // mouse move delta
        const delta = {
          x: element.clientX - mousedownInfo.element.clientX,
          y: element.clientY - mousedownInfo.element.clientY,
        };

        // delta considering min-height of panels
        const finalDelta =
            Math.min(
                Math.max(
                    delta.y,
                    -(mousedownInfo.panelTopHeight - parseInt(panelTop.css('min-height'), 10)),
                ),
                mousedownInfo.panelBottomHeight - parseInt(panelBottom.css('minHeight'), 10),
            );

        // set position of drag element and height of panels
        dragElement.css('top', (mousedownInfo.offsetTop + finalDelta) + 'px');
        panelTop.css('height', (mousedownInfo.panelTopHeight + finalDelta) + 'px');
        panelBottom.css('height', (mousedownInfo.panelBottomHeight - finalDelta) + 'px');
      }
    },
  },
};

